/**
 * Created by zhengyf on 2018.2.1.
 */

;(function () {
    TinyEditorService.$inject = ['$q', '$timeout'];
    angular
        .module('DSSXAPP')
        .service('TinyEditorService', TinyEditorService);

    function TinyEditorService($q, $timeout) {
        var instances = {}
        ;

        var defaultOptions = {
            elementpath: false,
            themes: "inlite",
            branding: false,
            height: 400,
            plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table contextmenu paste code',
                "contextmenu",
                "picAndWordCount",
                "textcolor",
                "searchreplace",
                "table",
                // "wordcount"
            ],
            content_css: [
                'css/normalEditorInnerStyle.css'
            ],
            contextmenu: "myMenuItem1 | myMenuItem2",
            toolbar: [
                'code | undo redo | fontselect | fontsizeselect | bold italic underline strikethrough forecolor superscript subscript removeformat | bullist numlist',
                'cut copy searchreplace | alignleft aligncenter alignright alignjustify | outdent indent | table | upload upload4bank | charmap fullscreen | link unlink'
            ],
            menubar: false,
            paste_remove_styles: true,
            paste_remove_styles_if_webkit: true,
            paste_strip_class_attributes: true,
            paste_auto_cleanup_on_paste: true,
            paste_preprocess: function (plugin, args) {
                args.content = strip_tags(args.content, 'table thead tr th tbody td tfoot caption col colgroup');
            }
        };

        function init(rbType, maxWordNum) {
            addPlugCountPicAndWord(rbType, maxWordNum);
        }

        this.createInstance = function (option, rbType, maxWordNum) {
            init(rbType, maxWordNum);
            return createEditorInstance(option);
        }

        this.getContent = function (id) {
            return instances[id].editor.getContent();
        };

        this.setContent = function (id, content) {
            return instances[id].editor.setContent(content);
        };

        this.getWordCount = function (id) {
            var count = instances[id].editor.plugins.picAndWordCount.getCount() || {};
            return count.word;
        };

        this.getPicCount = function (id) {
            var count = instances[id].editor.plugins.picAndWordCount.getCount() || {};
            return count.pic;
        };

        this.reCount = function (id) {
            instances[id].editor.plugins.picAndWordCount.update();
        }

        function addPlugCountPicAndWord(rbType, max) {

            rbType = rbType || 1;
            var maxWordNum = rbType === 2 ? 16000 : 20000;

            // todo 这里是为了配置旺铺的自定义内容，同时兼容其他页面的富文本做出的妥协，有空需要对富文本的配置参数进行修改
            max && (maxWordNum = max);

            tinymce.PluginManager.add('picAndWordCount', function (editor) {
                var bar = null;
                editor.on('init', init);
                editor.on('setcontent beforeaddundo keyup', update);

                function init() {
                    bar = $(editor.theme.panel.find('#statusbar')[0].$el.context);
                }

                function update(e) {
                    var html = getBar(rbType);
                    bar && bar.html(html);
                }

                function getCount() {
                    var tx = editor.getContent({format: 'raw'});
                    var decoded = decodeHtml(tx);
                    var picCount = getStrCount(decoded, "<img");
                    var tc = editor.getContent({format: 'text'}).length;

                    // todo 为旺铺做的配置
                    if (rbType === 2 && max) {
                        tc = tx.length;
                    }

                    // 修改编辑器功能按钮样式错乱的问题
                    $timeout(function () {
                        $('.mce-listbox').find('button').css({
                            paddingRight: 0
                        })
                    },0)

                    return {
                        word: maxWordNum - tc,
                        pic: 15 - picCount
                    };
                }

                function decodeHtml(html) {
                    var txt = document.createElement("textarea");
                    txt.innerHTML = html;
                    return txt.value;
                }

                function getStrCount(scrstr, armstr) {
                    var count = 0;
                    while (scrstr.indexOf(armstr) >= 1) {
                        scrstr = scrstr.replace(armstr, "");
                        count++;
                    }
                    return count;
                }

                function getBar(bar) {
                    var
                        html,
                        count = getCount()
                    ;

                    switch (bar) {
                        case 1:
                            html = '<div style="position: relative;height: 30px;padding: 5px">' +
                                '<div style="float: right;height: 30px;line-height: 30px;margin-right: 10px">剩余字数：<span id="product-launch-word-count" style="color: red;line-height: 30px">' + count.word + '</span></div> ' +
                                '<div style="float: right;height: 30px;line-height: 30px;margin-right: 10px">剩余图片张数：<span id="product-launch-img-count" style="color: red;line-height: 30px">' + count.pic + '</span></div> ' +
                                '</div>';
                            break;
                        case 2:
                            html = '<div style="position: relative;height: 30px;padding: 5px">' +
                                '<div style="float: right;height: 30px;line-height: 30px;margin-right: 10px">剩余字数：<span id="product-launch-word-count" style="color: red;line-height: 30px">' + count.word + '</span></div> ' +
                                '</div>';
                            break;
                        default:
                            html = '';
                    }

                    return html;
                }

                return {
                    getCount: getCount,
                    update: update
                }
            });
        }

        function createEditorInstance(option) {
            var id = Date.now();
            var deferred = $q.defer();

            instances[id] = {};


            tinymce.init(angular.extend({}, defaultOptions, option || {}, {
                init_instance_callback: function (editor) {
                    instances[id].editor = editor;
                    deferred.resolve({id: id, editor: editor});
                }
            }));

            return deferred.promise;
        }

        function strip_tags(str, allowed_tags) {
            str += '';

            var
                i,
                allowed,
                html,
                allowed_tag,
                allowed_array = [],
                matches = str.match(/(<\/?[\S][^>]*>)/gi) // // Match tags
            ;

            var replacer = function (search, replace, str) {
                return str.split(search).join(replace);
            };
            // Build allowes tags associative array
            if (allowed_tags) {
                allowed_array = allowed_tags.match(/([a-zA-Z0-9]+)/gi);
            }

            // Go through all HTML tags
            for (var key in matches) {
                if (isNaN(key)) {
                    // IE7 Hack
                    continue;
                }
                // Save HTML tag
                html = matches[key].toString();
                // Is tag not in allowed list? Remove from str!
                allowed = false;
                // Go through all allowed tags
                for (var k in allowed_array) {            // Init
                    allowed_tag = allowed_array[k];
                    i = -1;
                    if (i !== 0) {
                        i = html.toLowerCase().indexOf('<' + allowed_tag + '>');
                    }
                    if (i !== 0) {
                        i = html.toLowerCase().indexOf('<' + allowed_tag + ' ');
                    }
                    if (i !== 0) {
                        i = html.toLowerCase().indexOf('</' + allowed_tag);
                    }

                    // Determine
                    if (i === 0) {
                        allowed = true;
                        break;
                    }
                }
                if (!allowed) {
                    str = replacer(html, '', str); // Custom replace. No regexing
                }
            }
            return str;
        }

    }


})();
